import textFormatter from "common/TextFormatter";

export const renderMobileCellValue = (largeTableItem, largeTableColumns) => {
  return Object.keys(largeTableItem).map((property) => {
    const value = largeTableItem[property];
    if (!value) {
      return null;
    }
    const largeTableColumn = largeTableColumns.find((tableColumns) => tableColumns.name === property);
    if (!largeTableColumn) {
      return null;
    }
    const formattedValue = largeTableColumn.format ? largeTableColumn.format(value, largeTableItem) : value;
    return (
      <p key={property}>
        <label>{textFormatter.uppercaseFirst(largeTableColumn.label)}</label>
        <br />
        {formattedValue}
      </p>
    );
  });
};
